import { ThemeColors } from '~/themes/colors'

export interface SnippetSettingsColors {
  BorderColor: ThemeColors
  BackgroundColor: ThemeColors
  BackgroundColor2: ThemeColors
  BackgroundColor3: ThemeColors
  ErrorTextColor: ThemeColors
  isSelectedColor: ThemeColors
  MaxCountColor: ThemeColors
  MaxCountColor2: ThemeColors
  LoadingColor: ThemeColors
}

export const snippetSettingsColors: SnippetSettingsColors = {
  BorderColor: {
    default: 'gray.400',
  },
  BackgroundColor: {
    default: 'gray.100',
  },
  BackgroundColor2: {
    default: 'gray.300',
  },
  BackgroundColor3: {
    default: 'gray.500',
  },
  ErrorTextColor: {
    default: 'red.100',
  },
  isSelectedColor: {
    default: 'gray.200',
  },
  MaxCountColor: {
    default: 'red.800',
  },
  MaxCountColor2: {
    default: 'gray.800',
  },
  LoadingColor: {
    default: 'gray.600',
  },
}
